import React from 'react';
import MetricsGrid from './MetricsGrid';
import ChartsGrid from './ChartsGrid';
import './MetricsPage.css';

interface MetricsPageProps {
  timeRange?: string;
}

const MetricsPage: React.FC<MetricsPageProps> = ({ timeRange = 'Last 1h' }) => {
  return (
    <div className="metrics-page-container">
      <script
        type="text/javascript"
        dangerouslySetInnerHTML={{
          __html: `
            window._uxa = window._uxa || [];
            window._uxa.push(["trackDynamicVariable", { key: "metrics", value: "metrics_value" }]);
          `
        }}
      />
      <div className="metrics-page-header">
        <h1 className="page-title">Metrics & Charts</h1>
        <p className="page-subtitle">View all metrics and charts for your application</p>
      </div>

      {/* Metrics Section */}
      <div className="metrics-section">
        <h2 className="section-title">Key Metrics</h2>
        <MetricsGrid timeRange={timeRange} />
      </div>

      {/* Charts Section */}
      <div className="charts-section">
        <h2 className="section-title">Performance Charts</h2>
        <ChartsGrid timeRange={timeRange} />
      </div>
    </div>
  );
};

export default MetricsPage;
